import { IKpiData } from '../hrAnalytics.types'

export const MOCK_OVERVIEW_KPIS: IKpiData[] = [
  {
    value: '90.5%',
    label: 'ATTENDANCE RATE',
    trend: { value: '+1.2%', positive: true },
    accentColor: '#00B04C',
    iconKey: 'checkCircle',
  },
  {
    value: '4.9%',
    label: 'ABSENCE RATE',
    trend: { value: '-0.3%', positive: true },
    accentColor: '#FF4F46',
    iconKey: 'person',
  },
  {
    value: '97.6%',
    label: 'STAFFING COVERAGE',
    accentColor: '#30B6D1',
    iconKey: 'shield',
  },
  {
    value: '$245K',
    label: 'TOTAL PAYROLL',
    accentColor: '#ff9900',
    iconKey: 'dollar',
  },
  {
    value: '8,400',
    label: 'MEALS SERVED',
    sublabel: 'Across all kitchens',
    accentColor: '#9C27B0',
    iconKey: 'food',
  },
]

export const MOCK_OVERVIEW_CARDS = [
  {
    key: 'attendance',
    title: 'Attendance Analytics',
    description: 'Presence outcomes, absence patterns, department comparisons.',
    value: '90.5%',
    iconKey: 'person',
    path: '/hr/analytics/attendance',
  },
  {
    key: 'schedule',
    title: 'Schedule Analytics',
    description: 'Planned obligations vs finalized outcomes.',
    value: '97.6%',
    iconKey: 'calendar',
    path: '/hr/analytics/schedule',
  },
  {
    key: 'payroll',
    title: 'Payroll Analytics',
    description: 'Payroll costs, overtime trends, department distribution.',
    value: '$245K',
    iconKey: 'dollar',
    path: '/hr/analytics/payroll',
  },
  {
    key: 'logistics',
    title: 'Workforce Logistics',
    description: 'Food, accommodation, and mobility utilization.',
    value: '8,400',
    iconKey: 'truck',
    path: '/hr/analytics/logistics',
  },
]
